import ProductDetails from '../components/ProductDetails';

function ProductPage() {
	return (
		<div className='min-h-screen w-full xl:w-[1201px] px-4 mx-auto'>
			<ProductDetails />
		</div>
	);
}

export default ProductPage;
